// Hook personalizado para gestionar alertas

import { useState, useEffect, useCallback } from 'react'
import {
  getAlertsSettings,
  updateAlertsSettings,
  getPurchaseOrderAlerts
} from '../services/alerts.service'

/**
 * Hook para obtener configuración de alertas
 */
export const useAlertsSettings = () => {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getAlertsSettings()
      setSettings(data)
    } catch (err) {
      console.error('Error obteniendo configuración de alertas:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchSettings()
  }, [fetchSettings])

  const update = useCallback(async (settingsData) => {
    try {
      setLoading(true)
      setError(null)
      await updateAlertsSettings(settingsData)
      await fetchSettings()
    } catch (err) {
      console.error('Error actualizando configuración de alertas:', err)
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [fetchSettings])

  return { settings, loading, error, refetch: fetchSettings, update }
}

/**
 * Hook para obtener alertas de pedidos de compra
 */
export const usePurchaseOrderAlerts = () => {
  const [alerts, setAlerts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchAlerts = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getPurchaseOrderAlerts()
      setAlerts(data)
    } catch (err) {
      console.error('Error obteniendo alertas:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchAlerts()
    // Refrescar alertas cada 5 minutos
    const interval = setInterval(fetchAlerts, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [fetchAlerts])

  return { alerts, loading, error, refetch: fetchAlerts }
}

